export const AlertMessageActions = {
  RESET: 'resetAlertMessage',
};

export default {
  resetMessageList: () => ({ type: AlertMessageActions.RESET }),
};



// WEBPACK FOOTER //
// ./resources/assets/js/actions/alertMessage.js